module.exports = __webpack_public_path__ + "img/docMiss.43d610ec.svg";